// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VendorUser } from './vendor-user';
import {
    VendorUserFromJSON,
    VendorUserFromJSONTyped,
    VendorUserToJSON,
    VendorUserToJSONTyped,
} from './vendor-user';

/**
 * 
 * @export
 * @interface VendorUserListResponse
 */
export interface VendorUserListResponse {
    /**
     * 
     * @type {Array<VendorUser>}
     * @memberof VendorUserListResponse
     */
    items: Array<VendorUser>;
    /**
     * 
     * @type {string}
     * @memberof VendorUserListResponse
     */
    nextToken?: string;
}

/**
 * Check if a given object implements the VendorUserListResponse interface.
 */
export function instanceOfVendorUserListResponse(value: object): value is VendorUserListResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function VendorUserListResponseFromJSON(json: any): VendorUserListResponse {
    return VendorUserListResponseFromJSONTyped(json, false);
}

export function VendorUserListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): VendorUserListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(VendorUserFromJSON)),
        'nextToken': json['nextToken'] == null ? undefined : json['nextToken'],
    };
}

export function VendorUserListResponseToJSON(json: any): VendorUserListResponse {
    return VendorUserListResponseToJSONTyped(json, false);
}

export function VendorUserListResponseToJSONTyped(value?: VendorUserListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(VendorUserToJSON)),
        'nextToken': value['nextToken'],
    };
}
